import Dimensions from './dimensions'
import Metrics from './metrics'
import uuid from './uuid'

const TrackerId = 'UA-108803992-1'
const CurrentVersion = 1
const NoValue = '(not set)'

export const init = () => {
  window.ga =
    window.ga ||
    function() {
      ;(ga.q = ga.q || []).push(arguments)
    }
  ga.l = +new Date()

  createTracker()
  trackErrors()
  // setCustomDimensions()
  sendPageView('pageload')
  // sendNavigationTimingMetrics()
}

export const onRouteChanged = pathname => {
  ga(`set`, `page`, pathname)
  sendPageView('navigation')
}

const createTracker = () => {
  ga('create', TrackerId, 'auto')
  ga('set', 'transport', 'beacon')
}

const setCustomDimensions = () => {
  Object.keys(Dimensions).forEach(key => {
    ga('set', Dimensions[key], NoValue)
  })

  ga(tracker => {
    tracker.set({
      [Dimensions.TrackingVersion]: CurrentVersion,
      [Dimensions.ClientId]: tracker.get('clientId'),
      [Dimensions.WindowId]: uuid()
    })
  })

  ga(tracker => {
    const originalBuildHitTask = tracker.get('buildHitTask')
    tracker.set('buildHitTask', model => {
      const qt = model.get('queueTime') || 0
      model.set(Dimensions.HitId, uuid(), true)
      model.set(Dimensions.HitTime, String(new Date() - qt), true)
      model.set(Dimensions.HitType, model.get('hitType'), true)
      model.set(Dimensions.VisibilityState, document.visibilityState, true)

      originalBuildHitTask(model)
    })
  })
}

const sendNavigationTimingMetrics = () => {
  if (!(window.performance && window.performance.timing)) return

  if (document.readyState !== 'complete') {
    window.addEventListener('load', sendNavigationTimingMetrics)
    return
  }

  const nt = performance.timing
  const navStart = nt.navigationStart

  const responseEnd = Math.round(nt.responseEnd - navStart)
  const domLoaded = Math.round(nt.domContentLoadedEventStart - navStart)
  const windowLoaded = Math.round(nt.loadEventStart - navStart)

  const allValuesAreValid = (...values) =>
    values.every(value => value > 0 && value < 6e6)

  if (allValuesAreValid(responseEnd, domLoaded, windowLoaded)) {
    ga('send', 'event', {
      eventCategory: 'Navigation Timing',
      eventAction: 'track',
      eventLabel: NoValue,
      nonInteraction: true,
      [Metrics.ResponseEnd]: responseEnd,
      [Metrics.DomLoaded]: domLoaded,
      [Metrics.WindowLoaded]: windowLoaded
    })
  }
}

const sendPageView = source => {
  ga('send', 'pageview', { [Dimensions.HitSource]: source })
}

const trackErrors = () => {
  const loadErrorEvents = (window.__e && window.__e.q) || []

  const trackErrorEvent = event => {
    const fieldsObj = { eventCategory: 'Uncaught Error' }
    const err = event.error || {
      message: `${event.message} (${event.lineno}:${event.colno})`
    }

    trackError(err, fieldsObj)
  }

  for (const event of loadErrorEvents) {
    trackErrorEvent(event)
  }

  window.addEventListener('error', trackErrorEvent)
  window.removeEventListener('error', window.__e)
}

const trackError = () => {
  window.ga(
    'send',
    'event',
    Object.assign(
      {
        eventCategory: 'Error',
        eventAction: err.name || '(no error name)',
        eventLabel: `${err.message}\n${err.stack || '(no stack trace)'}`,
        nonInteraction: true
      },
      fieldsObj
    )
  )
}



// WEBPACK FOOTER //
// ./plugins/my-analytics-plugin/src/analytics.js